// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".breadcrumb-item {\n  z-index: 100;\n}", "",{"version":3,"sources":["webpack://./src/modules/navigation/components/breadcrumbs/breadcrumbs.component.scss"],"names":[],"mappings":"AAEA;EACI,YAAA;AADJ","sourcesContent":["@import 'styles/core/variables.scss';\n\n.breadcrumb-item {\n    z-index: 100;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
